<template>
    <div class="slicepart">
        <div class="box" v-if="sliceData.img">
          <img style="width: 100%;height: 90%;" :src="sliceData.img"/>
          <div  ref="mydiv" class="canvas" :style="{'height':height}"  @mousewheel="onMouseWheel">
               <div  class="line" :style="{'top':sliceIndex*sliceTop+'px'}" ></div>
          </div>
        </div>
        <div class="box" v-else>
        </div>
        <div class="text">
          <p>Slice </p>
          <ArrowLeft class="icon" @click="changeSlice(0)"/>
          <p> {{sliceData.list?sliceIndex+1:'--'}}/{{ sliceData.list?sliceData.list.length:'--' }}</p>
          <ArrowRight class="icon" @click="changeSlice(1)"/>
        </div>
    </div>
</template>

<script >
export default {
  name: 'slicePart',
  props: {
    sliceData: {
      type: Object,
      default: () => {}
    },
    scanIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {
    sliceData (newval, oldval) {
      this.init()
      this.sliceIndex = newval.index - 1
      console.log('this.sliceIndex', this.sliceIndex)
    },
    scanIndex (newval, oldval) {
      this.sliceIndex = this.sliceData.index - 1 // this.$store.state.sliceIndex
    },
    sliceIndex (newval, oldval) {
      console.log(newval, oldval, this.$store.state.sliceIndex)
      if (newval !== this.$store.state.sliceIndex) {
        this.sliceIndex = this.sliceData.index - 1
        this.sliceFlag = false
      }
    }
  },
  data () {
    return {
      sliceTop: 0,
      sliceIndex: this.sliceData.index - 1,
      height: '',
      sliceFlag: false
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      setTimeout(() => {
        if (this.sliceData.list) {
          // const height = this.$refs.mydiv.offsetHeight
          // if (this.sliceData.list.length !== 0) {
          //   const itop = (height / (this.sliceData.list.length - 1)).toFixed(0)
          //   this.sliceTop = itop
          // }
          this.sliceTop = this.sliceData.list.length > 25 ? 2 : 5
          this.height = (this.sliceData.list.length - 1) * this.sliceTop + 'px'
        }
      }, 1000)
    },
    /// 滾輪切換切片事件
    onMouseWheel (ev) {
      // let ev = ev || window.event
      var down = true // 定义一个标志，当滚轮向下滚时，执行一些操作
      down = ev.wheelDelta ? ev.wheelDelta < 0 : ev.detail > 0
      const len = this.sliceData.list.length - 1

      if (down) {
        console.log('鼠标滚轮向下')
        this.sliceIndex++
      } else {
        this.sliceIndex--
        console.log('鼠标滚轮向上')
      }
      if (this.sliceIndex < 0) {
        this.sliceIndex = 0
      } else if (this.sliceIndex > len) {
        this.sliceIndex = len
      }
      const obj = {
        url: this.sliceData.list[this.sliceIndex].url,
        index: this.sliceIndex
      }

      this.$emit('changeSclie', obj)
      if (ev.preventDefault) { /* FF 和 Chrome */
        ev.preventDefault()// 阻止默认事件
      }
      this.sliceFlag = true
      return false
    },
    changeSlice (flag) {
      const len = this.sliceData.list.length - 1
      if (flag === 0) {
        this.sliceIndex--
      } else {
        this.sliceIndex++
      }
      if (this.sliceIndex < 0) {
        this.sliceIndex = 0
      } else if (this.sliceIndex > len) {
        this.sliceIndex = len
      }
      const obj = {
        url: this.sliceData.list[this.sliceIndex].url,
        index: this.sliceIndex
      }
      this.$emit('changeSclie', obj)
      this.sliceFlag = true
    }
  }
}
</script>

<style lang="less" scoped>

.slicepart{
  .box{
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 250px;
    max-height: 250px;
    background-color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 100%;
      max-height: 250px;
    }
    .canvas {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        z-index: 10;
        width: 70%;
        height: 70%;
        background-color: #9CC99C;
        opacity: 0.3;
        .line{
          position: absolute;
          width: 100%;
          border: 1px solid #00FF00;
        }
    }
  }

  .text{
    display: flex;
    justify-content: left;
    align-items: center;
    p{
    text-align: left;
    font-size: 16px;
    color:#00A1AE;
    font-weight: bold;
  }
  .icon{
    font-size: 16px;
    width: 18px;
    height: 18px;
    color:#00A1AE;
    cursor: pointer;
  }
  }
}
@media screen and (min-height:1200px){
  .slicepart{
  .box{
    min-height: 300px;
    max-height: 300px;
    img{
      max-height: 300px;
    }
  }
}
}
</style>
